import { NeighborhoodProvider } from './context';
import { NeighborhoodContent } from './NeighborhoodContent';
import { NeighborhoodFooter } from './NeighborhoodFooter';

export const NeighborhoodModule = () => {
  return (
    <NeighborhoodProvider>
      <NeighborhoodContent />
      <NeighborhoodFooter />
    </NeighborhoodProvider>
  );
};
